<template>
    <information-content @redirect='redirectHome'>
        <template slot='title'>
            La ressource que vous demandez n'est pas accessible,
        </template>
        <template slot='label'>
            RETOUR VERS L'ACCUEIL
        </template>
    </information-content>
</template>

<script>
    import InformationContent from '../../components/layout/InformationContent';

    export default {
        components: {
            InformationContent
        },
        name: 'code404',
        methods: {
            redirectHome: function (event) {
                this.$router.push({name: 'base'});
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/response/Code404.vue